import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal from "@ebay/nice-modal-react";

DataTable.use(DT);

const ChatSessionsTable = ({ chatSessions = [], onUpdated = () => {} }) => {
  const tableRef = useRef(null);
  const [localChatSessions, setLocalChatSessions] = useState(chatSessions);

  useEffect(() => {
    if (chatSessions) {
      setLocalChatSessions(chatSessions);
    }
  }, [chatSessions]);

  window.view = (public_id) => {
    console.log("!!! chatSession VIEW: ", public_id);
    NiceModal.show("chat-session", { agent: null, chat_session_id: public_id });
  };

  const tableData = localChatSessions.map((chatSession) => {
    return [
      chatSession.public_id,
      chatSession.user_group,
      chatSession.email,
      chatSession.user,
      chatSession.message ?? "",
      chatSession.message_count,
      chatSession.rating,
      chatSession.feedback_text,
      chatSession.created_at ? new Date(chatSession.created_at) : "",
      chatSession.updated_at ? new Date(chatSession.created_at) : "",
      `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 50px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 14px; color: black;" onClick="window.view('${chatSession.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">View</button></div></div>`,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        ChatSessions ({chatSessions.length})
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[8, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Group</th>
            <th>Email</th>
            <th>User</th>
            <th>Message</th>
            <th>Count</th>
            <th>Rating</th>
            <th>Feedback</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default ChatSessionsTable;
